import cssHasPseudo from 'css-has-pseudo/browser';
cssHasPseudo(document);

import './components/*';

import $ from 'jquery';

$('img[data-attribution]').each((index, image) => {
  const $image = $(image);
  const attribution = $image.attr('data-attribution');
  $image.wrap('<div class="attribution-wrapper"></div>');
  $image.after(`
    <figcaption class="attribution">
      <span class="attribution__label">Photo credit</span> <!-- /.attribution__label -->
      <span class="attribution__value">${attribution}</span> <!-- /.attribution__value -->
    </figcaption> <!-- /.attribution -->
  `);
});
